import { z, isoZ } from 'my-zod'
import { TimeZoneEnum } from '../../internal/timezone'

export const GeneralAddressFragment = z.object({
  id: z.string().nullish(),
  attention: z.string().uuid().nullish(),
  addressLine1: z.string().min(1),
  addressLine2: z.string().nullish(),
  city: z.string().min(1),
  postalCode: z.string().min(1),
  stateProvince: z.string().min(1),
  country: z.string().nullish(),
  notes: z.string().nullish(),
  timezone: TimeZoneEnum.nullish().setLabel('Time zone'),
  webDescription: z.string().max(200).nullish(),
  originalAddress: z.string().nullish(),
  lastModifiedDate: isoZ.instant().nullish(),
  deletedDate: isoZ.instant().nullish(),
  serverLastModifiedDate: isoZ.instant().nullish()
})

export type GeneralAddressFragment = z.infer<typeof GeneralAddressFragment>

export function AddressToString(address: GeneralAddressFragment) {
  return `${address.addressLine1}
            ${address.addressLine2}
            ${address.city}, ${address.stateProvince} ${address.postalCode}
            `
}
